var SpinnerSvg = function SpinnerSvg(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M617.492 1123.797q0 60-42.5 102t-101.5 42q-60 0-102-42t-42-102q0-60 42-102t102-42q59 0 101.5 42t42.5 102zm432 192q0 53-37.5 90.5t-90.5 37.5q-53 0-90.5-37.5t-37.5-90.5q0-53 37.5-90.5t90.5-37.5q53 0 90.5 37.5t37.5 90.5zm-608-640q0 66-47 113t-113 47q-66 0-113-47t-47-113q0-66 47-113t113-47q66 0 113 47t47 113zm1040 448q0 46-33 79t-79 33q-46 0-79-33t-33-79q0-46 33-79t79-33q46 0 79 33t33 79zm-832-896q0 73-51.5 124.5t-124.5 51.5q-73 0-124.5-51.5t-51.5-124.5q0-73 51.5-124.5t124.5-51.5q73 0 124.5 51.5t51.5 124.5zm464-192q0 80-56 136t-136 56q-80 0-136-56t-56-136q0-80 56-136t136-56q80 0 136 56t56 136zm544 640q0 40-28 68t-68 28q-40 0-68-28t-28-68q0-40 28-68t68-28q40 0 68 28t28 68zm-208-448q0 33-23.5 56.5t-56.5 23.5q-33 0-56.5-23.5t-23.5-56.5q0-33 23.5-56.5t56.5-23.5q33 0 56.5 23.5t23.5 56.5z",
    fill: "currentColor"
  }));
};

SpinnerSvg.defaultProps = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 -256 1792 1792"
};
import styled, { keyframes } from '/web_modules/styled-components.js';
import React from '/web_modules/react.js';
import { motion } from '/web_modules/framer-motion.js';
const rotate = keyframes(["0%{-webkit-transform:rotate(0deg) scale(1);}100%{-webkit-transform:rotate(360deg) scale(1);}"]);
export const SpinnerWrap = styled(motion.figure).withConfig({
  displayName: "Spinner__SpinnerWrap",
  componentId: "sc-1kty7ob-0"
})(["svg{width:24px;height:24px;animation-timing-function:cubic-bezier(0.5,0.2,0.6,1);animation-name:", ";animation-duration:1.5s;animation-iteration-count:infinite;}"], rotate);

const SpinnerComponent = props => /*#__PURE__*/React.createElement(SpinnerWrap, props, /*#__PURE__*/React.createElement(SpinnerSvg, null));

export const Spinner = styled(SpinnerComponent).withConfig({
  displayName: "Spinner",
  componentId: "sc-1kty7ob-1"
})([""]);
export const ExpandedSpinner = styled(Spinner).withConfig({
  displayName: "Spinner__ExpandedSpinner",
  componentId: "sc-1kty7ob-2"
})(["height:100%;width:100%;display:flex;justify-content:center;align-items:center;svg{height:48px;width:48px;}"]);